import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { QUERY_KEYS } from 'constants/common';
import { CenterService } from 'services/centers';
import { DepartmentService } from 'services/departments';

export const useFetchPatientHealthCenter = (
  departmentId?: string | null
): UseQueryResult<string | null> =>
  useQuery({
    queryKey: [QUERY_KEYS.FETCH_DEPARTMENT, QUERY_KEYS.FETCH_CENTER, departmentId],
    queryFn: async (): Promise<string | null> => {
      if (!departmentId) return null;

      const { data: department } = await DepartmentService.getDepartment(departmentId);
      if (!department.centerEnterpriseId) return null;

      const { data: center } = await CenterService.getCenter(department.centerEnterpriseId);
      return center.centerName || null;
    },
    enabled: !!departmentId,
  });
